<template>
  <div class="module-header img-cover" :style="aStyle">
    <div
      v-if="role"
      class="role-select img-cover"
      :style="{
        backgroundImage: `url(${role.rolePath || defaultRoleImage}`,

        top: `${$unit(role.top)}`,
        right: `${$unit(role.right)}`
      }"
      @click="onSelectRole"
    >
      <p
        :style="{
          fontSize: `${$unit(role.fontSize)}`,
          color: `${role.fontColor}`
        }"
      >
        {{ userInfo?.role_name || '选择角色' }}
      </p>
    </div>
    <div
      v-if="download && download.btnSwitch"
      class="btn-header img-cover"
      :style="{
        backgroundImage: `url(${download.btnPath || defaultBtnImage}`,
        bottom: `${$unit(download.bottom)}`
      }"
      @click="jump(download.jumpPath)"
    ></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'McHeader',

  props: {
    imageValue: {
      type: Object,
      default: () => {}
    },
    role: {
      type: Object,
      default: () => {}
    },
    download: {
      type: Object,
      default: () => {}
    },
    moduleId: {
      type: Number
    },
    viewStatus: {
      type: Number
    }
  },

  computed: {
    ...mapGetters(['userInfo']),
    aStyle() {
      return {
        height: this.$unit(this.bgHeight),
        backgroundImage: `url(${
          this.imageValue.imagePath || this.defaultImage
        })`
      };
    }
  },

  data() {
    return {
      defaultImage:
        'https://yxfile.3k.com/2023/02/23/upload_37zi65cv09kkocv9s689qbahovdorhpa.jpg',
      defaultRoleImage:
        'https://yxfile.3k.com/2023/02/23/upload_pjnrnkf3sei117mon8mskj6pnc6js9m4.png',
      defaultBtnImage:
        'https://yxfile.3k.com/2023/02/23/upload_bcotpyzflbcgli02fjvsywyk4q5358si.gif',
      bgHeight: 954
    };
  },
  watch: {
    imageValue() {
      this.init();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let img = new Image();
      img.onload = () => {
        let h = img.height;
        this.bgHeight = h;
      };
      img.src = this.imageValue.imagePath;
    },
    onSelectRole() {
      if (this.userInfo.guid === '') {
        this.$store.commit('OPEN_DIALOG', 'Guid');
      } else {
        this.$store.commit('OPEN_POPUP', 'QuickRole');
      }
    },
    jump(url) {
      if (!url || url == '') return;
      if (this.viewStatus == 1) return;
      this.Track(2, this.moduleId);
      setTimeout(() => {
        window.location.href = url;
      }, 1000);
    }
  }
};
</script>

<style lang="scss" scoped>
.img-cover {
  background-repeat: no-repeat;
  background-size: cover;
}
.module-header {
  position: relative;
  width: 100%;
  height: 954px;
}
.role-select {
  width: 162px;
  height: 56px;
  position: absolute;
  z-index: 400;
  p {
    line-height: 60px;
    width: 142px;
    margin: 0 10px;
    text-align: center;
    color: #fff;
    font-size: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
  }
}
.btn-header {
  width: 337px;
  height: 100px;
  position: absolute;
  left: 50%;
  bottom: 30px;
  transform: translateX(-50%);
  z-index: 400;
}
</style>
